var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CellDropdown", {
        attrs: { clearable: true, multiple: true },
        model: {
          value: _vm.selectedCellIds,
          callback: function($$v) {
            _vm.selectedCellIds = $$v
          },
          expression: "selectedCellIds"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }